var map = {
	"app/pages/admin/admin.module": [
		"./src/app/pages/admin/admin.module.ts",
		"default~app-pages-admin-admin-module~app-pages-auth-auth-module~app-pages-dashboard-dashboard-module~6f25115f",
		"default~app-pages-admin-admin-module~app-pages-dashboard-dashboard-module",
		"common",
		"app-pages-admin-admin-module"
	],
	"app/pages/auth/auth.module": [
		"./src/app/pages/auth/auth.module.ts",
		"default~app-pages-admin-admin-module~app-pages-auth-auth-module~app-pages-dashboard-dashboard-module~6f25115f",
		"app-pages-auth-auth-module"
	],
	"app/pages/dashboard/dashboard.module": [
		"./src/app/pages/dashboard/dashboard.module.ts",
		"default~app-pages-admin-admin-module~app-pages-auth-auth-module~app-pages-dashboard-dashboard-module~6f25115f",
		"default~app-pages-admin-admin-module~app-pages-dashboard-dashboard-module",
		"app-pages-dashboard-dashboard-module"
	],
	"app/pages/settings/settings.module": [
		"./src/app/pages/settings/settings.module.ts",
		"default~app-pages-admin-admin-module~app-pages-auth-auth-module~app-pages-dashboard-dashboard-module~6f25115f",
		"common",
		"app-pages-settings-settings-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;